module.exports = __webpack_public_path__ + "img/toolsItem13.a094fdc6.png";